<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h2 class="page-title"><i class="fas fa-globe"></i> Landing</h2>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <p>Landing content</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Landing_bSales",
    components: {},
    data() {
        return {};
    },
    created() {},
    methods: {},
    computed: {},
};
</script>
<style lang="scss" scoped>
</style>
